<template>
  <div class="elenco-trattative">

    <ricerca v-show="ricercaPanelVisible"
              @closeRicerca="closeSearch"
              @stopLoading="stopLoading"
              @ricerca="ricerca"
              @resetPaginator="resetPaginator">
    </ricerca>

    <div class="header-tab row row-custom">
      <div class="col-4 no-padding icon-search">
        <el-button @click="openSearch">
          <el-tooltip class="item" effect="dark" :content="$t('elencoTrattative.ricerca')" placement="top-start">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-tooltip>
        </el-button>
      </div>
      <div class="label-left col-16 no-padding">
        {{ $t('elencoTrattative.elencoTrattative').toUpperCase() }}
      </div>
    </div>

    <div class="elenco">
      <el-table :data="elencoTrattative" class="col-24 no-padding custom-table" v-loading="loading" @sort-change="sortChange">

        <el-table-column
          prop="date" header-align="center" align="center"
          width="45">
          <template slot-scope="scope">
            <icon v-if="(scope.row.statoAvanzamento === 'B')" name="riv-pencil" scale="1" style="color: #FFDD00"></icon>
            <icon v-if="(scope.row.statoAvanzamento === 'C')" name="riv-save" scale="1" style="color: #707070"></icon>
            <icon v-if="(scope.row.statoAvanzamento === 'D')" name="riv-controlloSic" scale="1" style="color: #1EE940"></icon>
            <icon v-if="(scope.row.statoAvanzamento === 'E')" name="riv-delete" scale="1" style="color: #E96A6A"></icon>
          </template>
        </el-table-column>

        <el-table-column
          prop="numTrattativa" header-align="center" align="center" sortable
          :label="($t('elencoTrattative.numeroTrattativa'))"
          min-width="135">
        </el-table-column>

        <el-table-column
          prop="datTrattativa" header-align="center" align="center" sortable
          :label="($t('elencoTrattative.data'))"
          min-width="90">
        </el-table-column>

        <el-table-column
          header-align="center" align="center"
          :label="($t('elencoTrattative.periodoValidita'))"
          min-width="175">
          <template slot-scope="scope">
            {{ scope.row.datValDa + ' - ' + scope.row.datValA }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center" align="center"
          min-width="175">
          <template slot="header">
            <span v-html="($t('elencoTrattative.periodoConsSped'))"></span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.datConsDa + ' - ' + scope.row.datConsA }}
          </template>
        </el-table-column>

        <el-table-column
          prop="desStab" header-align="center" align="center"
          min-width="150">
          <template slot="header">
            <span v-html="($t('elencoTrattative.stabilimentoDest'))"></span>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center" align="center"
          prop="numConf"
          :label="($t('elencoTrattative.conferma'))"
          min-width="110">
        </el-table-column>

        <el-table-column
          prop="desEleLoc"
          :label="($t('elencoTrattative.localitaProv'))"
          min-width="250">
        </el-table-column>

        <el-table-column
          prop="address"
          width="90">
          <template slot-scope="scope">
            <div class="row row-custom">
              <div class="col-8 no-padding" @click="duplicaTrattativa(scope.row)">
                <el-tooltip class="item" effect="dark" :content="($t('elencoTrattative.duplicaTrattativa'))" placement="top">
                  <icon name="riv-duplicate" scale="1" class="pointer"></icon>
                </el-tooltip>
              </div>
              <div class="col-8 no-padding" @click="goToDelete(scope.row)" v-if="(scope.row.statoAvanzamento !== 'D' && scope.row.statoAvanzamento !== 'E')">
                <el-tooltip class="item" effect="dark" :content="($t('elencoTrattative.elimina'))" placement="top">
                  <icon name="riv-delete2" scale="1" class="pointer"></icon>
                </el-tooltip>
              </div>
              <div class="col-8 no-padding" v-else>
                <!-- -->
              </div>
              <div class="col-8 no-padding" @click="goToDettaglio(scope.row)">
                <el-tooltip class="item" effect="dark" :content="($t('elencoTrattative.visualizzaTrattativa'))" placement="top">
                  <icon name="riv-arrow" scale="1" class="pointer"></icon>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage"
                   class="custom-pagination"
                   background
                   layout="prev, pager, next"
                   :total="nrItems"
                   :page-size="pag_for"
                   @current-change="changePage">
    </el-pagination>

  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import Ricerca from './Ricerca.vue'

  export default {
    name: 'ElencoTrattative',
    components: {Ricerca},
    i18n: {
      messages: {
        it_IT: {
          elencoTrattative: {
            elencoTrattative: 'Elenco Trattative',
            ricerca: 'Ricerca',
            numeroTrattativa: 'N. Trattativa',
            data: 'Data',
            periodoValidita: 'Periodo Validità',
            periodoConsSped: 'Periodo<br>consegna/spedizione',
            stabilimentoDest: 'Stabilimento di<br>destinazione',
            conferma: 'Conferma',
            localitaProv: 'Località di Provenienza',
            visualizzaTrattativa: 'Visualizza Trattativa',
            elimina: 'Elimina',
            duplicaTrattativa: 'Duplica Trattativa',
            confermaDelete: 'Vuoi davvero cancellare la trattativa?',
            attenzione: 'Attenzione',
            annulla: 'Annulla',
            prosegui: 'Prosegui'
          }
        },
        fr_FR: {
          elencoTrattative: {
            elencoTrattative: 'Liste de Négociations',
            ricerca: 'Rechercher',
            numeroTrattativa: 'N. Négociation',
            data: 'Date',
            periodoValidita: 'Période validité',
            periodoConsSped: 'Periodo<br>consegna/spedizione',
            stabilimentoDest: 'Stabilimento di<br>destinazione',
            conferma: 'Conferma',
            localitaProv: 'Località di Provenienza',
            visualizzaTrattativa: 'Visualizza Trattativa',
            elimina: 'Elimina',
            duplicaTrattativa: 'Duplica Trattativa',
            confermaDelete: 'Vuoi davvero cancellare la trattativa?',
            attenzione: 'Attenzione',
            annulla: 'Annulla',
            prosegui: 'Prosegui'
          }
        },
        es_ES: {
          elencoTrattative: {
            elencoTrattative: 'Elenco Trattative',
            ricerca: 'Ricerca',
            numeroTrattativa: 'N. Trattativa',
            data: 'Data',
            periodoValidita: 'Periodo Validità',
            periodoConsSped: 'Periodo<br>consegna/spedizione',
            stabilimentoDest: 'Stabilimento di<br>destinazione',
            conferma: 'Conferma',
            localitaProv: 'Località di Provenienza',
            visualizzaTrattativa: 'Visualizza Trattativa',
            elimina: 'Elimina',
            duplicaTrattativa: 'Duplica Trattativa',
            confermaDelete: 'Vuoi davvero cancellare la trattativa?',
            attenzione: 'Attenzione',
            annulla: 'Annulla',
            prosegui: 'Prosegui'
          }
        },
        de_DE: {
          elencoTrattative: {
            elencoTrattative: 'Schrottverhandlungen liste',
            ricerca: 'Suchen',
            numeroTrattativa: 'Verhandlung N.',
            data: 'Datum',
            periodoValidita: 'Gueltigkeit',
            periodoConsSped: 'Liefertermin',
            stabilimentoDest: 'Werk',
            conferma: 'Bestellung',
            localitaProv: 'Ursprungsort',
            visualizzaTrattativa: 'Verhandlung Anzeigen',
            elimina: 'Beseitigen',
            duplicaTrattativa: 'Doppelte Verhandlung',
            confermaDelete: 'Möchten Sie die Verhandlung Abbrechen?',
            attenzione: 'Vorsicht',
            annulla: 'Stornieren',
            prosegui: 'Fortsetzen'
          }
        },
        en_GB: {
          elencoTrattative: {
            elencoTrattative: 'Elenco Trattative',
            ricerca: 'Ricerca',
            numeroTrattativa: 'N. Trattativa',
            data: 'Data',
            periodoValidita: 'Periodo Validità',
            periodoConsSped: 'Periodo<br>consegna/spedizione',
            stabilimentoDest: 'Stabilimento di<br>destinazione',
            conferma: 'Conferma',
            localitaProv: 'Località di Provenienza',
            visualizzaTrattativa: 'Visualizza Trattativa',
            elimina: 'Elimina',
            duplicaTrattativa: 'Duplica Trattativa',
            confermaDelete: 'Vuoi davvero cancellare la trattativa?',
            attenzione: 'Attenzione',
            annulla: 'Annulla',
            prosegui: 'Prosegui'
          }
        }
      }
    },
    data () {
      return {
        ricercaPanelVisible: false,
        loading: false,
        codLang: sessionStorage.getItem('codLang'),
        elencoTrattative: [],
        pag_for: 11,
        currentPage: 1,
        nrPages: 0,
        nrItems: 0,
        ordine: '',
        codForn: ''
      }
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    mounted: function () {
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'elencoTrattative', [])
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'elencoTrattative', [])
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
      })
    },
    methods: {
      init: function () {
        let trattativaForm = this.$store.state.trattativaForm
        if (trattativaForm !== undefined && Object.keys(trattativaForm).length !== 0 && trattativaForm.constructor === Object) {
          this.$set(this, 'codForn', (trattativaForm.fornitore.codForn !== undefined) ? (trattativaForm.fornitore.tipForn + trattativaForm.fornitore.codForn) : '')
          this.ricerca()
        }
      },
      resetDati: function () {
        this.$set(this, 'ricercaPanelVisible', false)
        this.$set(this, 'loading', false)
        this.$set(this, 'elencoTrattative', [])
      },
      resetPaginator: function () {
        this.$set(this, 'currentPage', 1)
      },
      openSearch: function () {
        this.$set(this, 'ricercaPanelVisible', true)
      },
      closeSearch: function () {
        this.$set(this, 'ricercaPanelVisible', false)
      },
      stopLoading: function () {
        this.$set(this, 'loading', false)
      },
      goToDettaglio: function (trattativa) {
        this.$store.commit('setTrattativa', trattativa)
        this.$store.commit('setIfNuovaTrattativa', false)
        this.$store.commit('setIfDuplicaTrattativa', false)
        this.$router.push({ name: 'DettaglioTrattativa' })
      },
      duplicaTrattativa: function (trattativa) {
        this.$store.commit('setTrattativa', trattativa)
        this.$store.commit('setIfNuovaTrattativa', true)
        this.$store.commit('setIfDuplicaTrattativa', true)
        this.$router.push({ name: 'DettaglioTrattativa' })
      },
      changePage: function (page) {
        this.$set(this, 'currentPage', page)
        this.ricerca()
      },
      sortChange: function ({column, prop, order}) {
        if (prop === 'numTrattativa') {
          this.$set(this, 'ordine', (order === 'ascending') ? '1A' : '1D')
        } else if (prop === 'datTrattativa') {
          this.$set(this, 'ordine', (order === 'ascending') ? '2A' : '2D')
        } else {
          this.$set(this, 'ordine', '')
        }
        this.$set(this, 'currentPage', 1)
        this.ricerca()
      },
      ricerca: function () {
        this.$set(this, 'ricercaPanelVisible', false)
        this.$set(this, 'loading', true)
        let form = this.$store.state.trattativaForm
        this.$set(this, 'codForn', (form.fornitore.codForn !== undefined) ? (form.fornitore.tipForn + form.fornitore.codForn) : '')
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/trattative', {
          params: {
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1),
            pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
            pag_from: this.currentPage - 1,
            pag_for: this.pag_for,
            idOrdin: this.ordine,
            codSoc: form.stabDest.codSoc,
            codStab: form.stabDest.codStab,
            codLocalita: form.locProv,
            numTrattativa: form.numTrattativa,
            datTrattativa: form.dataTrattativa,
            datValDa: (form.periodoVal.length > 0) ? form.periodoVal[0] : '',
            datValA: (form.periodoVal.length > 0) ? form.periodoVal[1] : '',
            datConsDa: (form.periodoConsSped.length > 0) ? form.periodoConsSped[0] : '',
            datConsA: (form.periodoConsSped.length > 0) ? form.periodoConsSped[0] : '',
            statoAvanz: form.statoAvanz
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'elencoTrattative', response.body.data)
              if (this.currentPage === 1) {
                this.$set(this, 'nrItems', parseInt(response.body.attrib.size))

                let resto = parseInt(response.body.attrib.size) % this.pag_for
                let aggiunta = (resto > 0) ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.pag_for) + aggiunta
                this.$set(this, 'nrPages', nrPages)
              }
            } else {
              this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
              })
              this.$set(this, 'elencoTrattative', [])
              this.$set(this, 'nrPages', 0)
              this.$set(this, 'nrItems', 0)
            }
            this.$set(this, 'loading', false)
          })
      },
      goToDelete: function (trattativa) {
        this.$confirm(this.$t('elencoTrattative.confermaDelete'), this.$t('elencoTrattative.attenzione').toUpperCase(), {
          confirmButtonText: this.$t('elencoTrattative.prosegui'),
          cancelButtonText: this.$t('elencoTrattative.annulla'),
          type: 'warning',
          customClass: 'custom-confirm',
          showClose: false
        }).then(() => {
          this.deleteTrattativa(trattativa)
        }).catch(() => {
          //
        })
      },
      deleteTrattativa: function (trattativa) {
        let form = this.$store.state.trattativaForm
        this.$http.delete(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/trattativa', {
          params: {
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1),
            numTrattativa: trattativa.numTrattativa,
            datTrattativa: trattativa.datTrattativa,
            codStab: trattativa.codStab
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.ricerca()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";
  @import "../../../assets/less/el-table.less";
  @import "../../../assets/less/el-pagination.less";

  .elenco-trattative {
    .header-tab {
      height: 65px;
      text-align: center;
      .label-left {
        line-height: 65px;
        .set-font(@color: @oroRiva, @size: 22px, @family: 'os-semibolditalic');
      }
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .elenco {
      margin-top: 20px;
      .el-table {
        .cell {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneTrattativa/ElencoTrattative.vue